var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.dataset.class,attrs:{"type":_vm.dataset.type,"color":_vm.dataset.color}},[(_vm.dataset.icon)?[_c('v-icon',[_vm._v("mdi mdi-"+_vm._s(_vm.dataset.icon)+"  ")])]:_vm._e(),_vm._v("\n  "+_vm._s(_vm.dataset.label)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }